import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  IncreaseOfShareCapital,
  IncreaseOfShareCapitalForm,
  toPeriodForSubscription,
  toProperties,
} from "./increaseOfShareCapitalDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<IncreaseOfShareCapital>,
  data?: IncreaseOfShareCapital,
): IncreaseOfShareCapitalForm {
  return new IncreaseOfShareCapitalForm(dispatch, context, data);
}

export function isValid(form: IncreaseOfShareCapitalForm): boolean {
  return form.isValid;
}

export function validate(form: IncreaseOfShareCapitalForm): boolean {
  return form.validate();
}

export function applyForm(form: IncreaseOfShareCapitalForm): IncreaseOfShareCapital {
  return {
    type: DecisionType.increaseOfShareCapital,
    quickSetupType: form.quickSetupType,
    properties: toProperties(form.properties, form.contributionTypes.selected),
    isSubscriptionForm: form.isSubscriptionForm.value,
    isOtherSigningForAllSubscribers: form.isOtherSigningForAllSubscribers.value,
    signersForAllSubscribers: form.signersForAllSubscribers.map((d) => d),
    periodForSubscription: toPeriodForSubscription(form.periodForSubscription),
    deadlineForSubscription: form.deadlineForSubscription.toISOString(),
    isDisposableAccount: form.isDisposableAccount.value,
    isAccountGiven: form.isAccountGiven.value,
    accountNumber: form.accountNumber.validatedValue,
    usePowerOfAttorney: form.usePowerOfAttorney.value,
    powerOfAttorneyDate: form.powerOfAttorneyDate.toISOString(),
    powerOfAttorneyText: form.powerOfAttorneyText.validatedValue,
    estimatedCosts: form.estimatedCosts.toNumber(),
    specialCircumstancesUponSubscription: form.specialCircumstancesUponSubscriptionModel.value,
    specialCircumstancesUponSubscriptionTexts: form.specialCircumstancesUponSubscriptionTexts.map(
      (t) => ({ language: t.locale, text: t.model.validatedValue }),
    ),
    specialCircumstancesAfterLastApprovedAnnualAccount:
      form.specialCircumstancesAfterLastApprovedAnnualAccountModel.value,
    specialCircumstancesAfterLastApprovedAnnualAccountTexts:
      form.specialCircumstancesAfterLastApprovedAnnualAccountTexts.map((t) => ({
        language: t.locale,
        text: t.model.validatedValue,
      })),
    contributionTypes: form.contributionTypes.selected,
    updateArticlesAutomatically: form.updateArticlesAutomatically.value,
    articleOfAssociationNumber: form.articleOfAssociationNumber.selected,
    articleChanges: form.articleChangeModel.articleChanges.map((d) => d),
    updateCommitmentAutomatically: form.updateCommitmentAutomatically.value,
    includeSubscribersAsAttachment: form.isIncludeSubscribersAsAttachment.value,
  };
}

export const increaseOfShareCapitalHandler: DecisionTypeHandler<
  DecisionType.increaseOfShareCapital,
  IncreaseOfShareCapital,
  IncreaseOfShareCapitalForm
> = {
  type: DecisionType.increaseOfShareCapital,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent(form, event) {
    form.handleEvent(event);
  },
};
